import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';
import InfoIcon from 'ggApp/shared/icons/Info';
import { InfoCard } from 'ggApp/modules/newCheckout/components/InfoCard';
import { LineItemCard } from 'ggApp/modules/newCheckout/components/LineItemCard';

export const Container = styled.section`
    display: flex;
    flex-direction: column;

    & > * {
        flex-shrink: 0;
    }
`;

export const MixWrap = styled.div`
    margin-bottom: 8px;
`;

export const Header = styled.h2`
    ${(props) => props.theme.typography.Headline};
    text-align: center;
    margin-top: 24px;
`;

export const SubHeader = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    margin: 8px 0px;
    color: ${({ theme }) => theme.colors['Level 5']};
    text-align: center;
`;

export const Card = styled(InfoCard)`
    margin-top: 8px;
`;

export const ShippingNote = styled.div`
    display: flex;
    margin-top: 16px;
    color: ${({ theme }) => theme.colors['Level 5']};
    background-color: rgba(255, 199, 0, 0.1);
    border-radius: 8px;
    padding: 8px;
`;

export const ShippingNoteText = styled.p`
    ${(props) => props.theme.typography.TinyParagraph};
`;

export const SmallHeadline = styled.p`
    ${(props) => props.theme.typography.SmallHeadline};
`;

export const Info = styled(InfoIcon)`
    min-width: 20px;
    margin-right: 8px;
`;

export const RentInfo = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
`;

export const Button = styled(ButtonV2)`
    margin-top: 8px;
`;

export const ProductCard = styled(LineItemCard)`
    margin-bottom: 8px;
    padding: 16px;
    align-items: center;
`;
